import { CustomAvField, CustomSelect } from "components/Common/Input"
import { parameterCode } from "constant/utility"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Row } from "reactstrap"

const FilterForm = ({ model, t }) => {
  return (
    <>
      <Row>
        <div className="mb-3">
          <CustomAvField
            label={t("Contact Search")}
            name="search"
            type="text"
            className="form-input"
            placeholder={t("Search")}
            value={model.search}
          />
        </div>
      </Row>
      <Row>
        <div className="mb-3">
          <CustomSelect
            label={t("Contact Role")}
            portal
            name="contactRole"
            value={model.contactRole}
            code={parameterCode.CONTACT_ROLE_CODE}
          />
        </div>
      </Row>
    </>
  )
}

FilterForm.propTypes = {
  model: PropTypes.object,
  t: PropTypes.any,
}

export default withTranslation(["partyPage", "common"])(FilterForm)
